var render, staticRenderFns
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"
import style0 from "./RedirectView.vue?vue&type=style&index=0&id=2bcd02f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd02f1",
  null
  
)

export default component.exports